import { useMemo } from "react"
import { useTranslation } from "react-i18next";
import ReactEcharts from "echarts-for-react";
import { useMediaQuery } from "@material-ui/core";
import multiTooltip from "./multi-tooltip";

const SalesGraph = (props) => {
    const { dataAmount, dataSales, days, longDays } = props;
    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'allClientsScreen' });
    const showHorizontally = useMediaQuery("(max-width:600px)");

    const option = useMemo(() => {
        if (!dataAmount || !dataSales) return;

        const graphdataAmount = dataAmount.map((item) => [item.day_of_week, item.value]);
        const graphdataSales = dataSales.map((item) => [item.day_of_week, item.value]);
        const dimensions = ['dow', 'value']
        let encode, grid, xAxis, yAxis
        const categoryAxis = {
            type: 'category',
            data: days
        }
        const valuesAxis = [
            {
                type: 'value',
                name: t("averageAmountLabel"),
                alignTicks: true,
                nameLocation: showHorizontally ? 'middle' : 'end'
            },
            {
                type: 'value',
                name: t("averageSalesLabel"),
                alignTicks: true,
                nameLocation: showHorizontally ? 'middle' : 'end'
            },
        ]

        if (showHorizontally) {
            encode = { x: 'value', y: 'dow' }
            grid = {}
            xAxis = valuesAxis
            yAxis = categoryAxis
        } else {
            encode = { x: 'dow', y: 'value' }
            grid = { top: 44, bottom: 24 }
            xAxis = categoryAxis
            yAxis = valuesAxis
        }

        const option = {
            grid,
            xAxis,
            yAxis,
            series: [
                {
                    name: t("averageAmountLabel"),
                    type: 'bar',
                    data: graphdataAmount,
                    itemStyle: { color: '#00a4e0' },
                    dimensions,
                    encode
                },
                {
                    name: t("averageSalesLabel"),
                    type: 'line',
                    xAxisIndex: showHorizontally ? 1 : 0,
                    yAxisIndex: showHorizontally ? 0 : 1,
                    data: graphdataSales,
                    itemStyle: { color: "#487C40" },
                    lineStyle: { color: "#69B75C" },
                    dimensions,
                    encode
                }
            ],
            tooltip: {
                trigger: 'axis',
                confine: true,
                axisPointer: {
                    axis: showHorizontally ? 'y' : 'x',
                },
                formatter: (params) => multiTooltip({
                    params,
                    formatByIndex: true,
                    formatAxisValueFn: (value) => longDays[value],
                    formatFn: (value) => value.toFixed(2)
                })
            },
        };
        return option;
    }, [dataAmount, dataSales, showHorizontally, i18n.language, days, longDays])


    return (
        <div className="dashboardView-card cdb-salesgraph dashboard-graph-card" >
            <p className="dashboardView-card-title">{t("weeklySales")}</p>

            {
                option
                    ? <ReactEcharts
                        option={option}
                        style={{ height: '100%' }}
                    />
                    : <p>N/D</p>
            }
        </div>
    );
}

export default SalesGraph